module.exports = __webpack_public_path__ + "img/ruijie.9476dc3b.png";